import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createChangeCardNameCommand } from '../../../api/commands/factory';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class UpdateCardTitle extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdateCardTitle';

    public constructor(public id: string, public title: string, public isDispatchedByDetailsModal: boolean = false) {
        super(UpdateCardTitle.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UpdateCardTitle): Promise<boolean> => {
    if (!action.isDispatchedByDetailsModal) {
        useSendCommandAsync(action, {
            createCommand: () => createChangeCardNameCommand(action),
        });
    }

    return true;
};

const reducer = (state: StorymapState, action: UpdateCardTitle): void => {
    const card = getCardById(action.id);

    if (card) {
        card.title = action.title;
        card.isTitleEditing = false;
        card.lastUpdatedAt = new Date();

        if (!action.isDispatchedByRealTimeCallback) {
            dispatch(new FlashJustDragged());
        }
    }
};

//@ts-ignore
registerMiddleware(UpdateCardTitle.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdateCardTitle.ACTION_TYPE, reducer);
